import { render, staticRenderFns } from "./DailyUpdates.vue?vue&type=template&id=2aa95100&scoped=true&"
import script from "./DailyUpdates.vue?vue&type=script&lang=js&"
export * from "./DailyUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa95100",
  null
  
)

export default component.exports